enum Role {
    Hatchet = "Hatchet",
    RedGuard = "RedGuard",
    Demolitionist = "Demolitionist",
    Voidwarden = "Voidwarden",
    Brute = "Brute",
    Scoundrel = "Scoundrel",
    Spellweaver = "Spellweaver",
    Tinkerer = "Tinkerer",
    Mindthief = "Mindthief",
    Cragheart = "Cragheart",
    Sun = "Sun",
    Three_Spears_Three_Arrows = "Three_Spears_Three_Arrows",
    Circles_Ubisoft = "Circles_Ubisoft",
    Eclipse_Moon = "Eclipse_Moon",
    Cthulhu_Mindflayer = "Cthulhu_Mindflayer",
    Lightning_Bolt = "Lightning_Bolt",
    Music_Note = "Music_Note",
    Angry_Face_Spiky_Face_Totem_Face = "Angry_Face_Spiky_Face_Totem_Face",
    Saw = "Saw",
    Triforce_Triangles = "Triforce_Triangles",
    Two_Mini_Phoenix_Flaming_Cow = "Two_Mini_Phoenix_Flaming_Cow",
    DungeonMaster = "DungeonMaster",
    Spectator = "Spectator",
    Monster = "Monster"
}
